<script lang="ts">
  import ArrowLink from "$lib/atoms/ArrowLink.svelte";
  import resizeImage from "$lib/utils/resizeImage";
  import PostCardSubheading from "$lib/molecules/newsroom/helper/PostCardSubheading.svelte";
  import { parseUrl } from "$lib/utils/helpers";
  export let post: any;
  export let isLast: boolean;
  let isExternalLink = post?.content?.externalLink?.url?.length > 0;
  let titleElementId = `post-${post.full_slug.split("/").pop()}`;
</script>

{#if post && post.full_slug}
  <a
    href={post?.content?.externalLink?.url || "/" + parseUrl(post.full_slug)}
    target={isExternalLink ? "_blank" : ""}
    rel={isExternalLink ? "noopener noreferrer" : ""}
    class={`flex flex-col md:flex-row group   no-underline`}
  >
    <div
      class="md:w-[20%] lg:w-2/12 flex-[0_0_auto] type:h6-small uppercase pr-4 pb-[.8rem]"
    >
      {post.post_date_short}
    </div>
    <div
      class="flex-auto {isLast
        ? ''
        : 'mb-8 pb-8 sm:mb-[1.75rem] sm:pb-[1.75rem] xl:mb-[2.5%] xl:pb-[2.5%]'}"
      style={`${isLast ? "" : "border-bottom:1px solid rgb(221, 220, 218)"}`}
    >
      <div class={`flex flex-col sm:flex-row`}>
        <div class="space-y-[.8rem] md:max-w-[65%] w-full pr-6">
          <h3
            class="type:h6-large text-charcoal line-clamp-2"
            id={titleElementId}
          >
            {@html post?.content?.previewHeading || post.name}
          </h3>
          {#if post?.content?.previewTeaser?.length > 0}
            <div class="type:body-medium text-[#4B4B4B] line-clamp-1 sm:mr-8">
              {post.content.previewTeaser}
            </div>
          {/if}
        </div>
        <div
          class="hidden md:flex flex-auto md:self-center items-center md:justify-end"
        >
          <ArrowLink
            noText={true}
            class="bg-grey reduced hover-red-bg"
            labelElement={titleElementId}
          />
        </div>
      </div>
    </div>
  </a>
{/if}
